import React from 'react';

/**
 * Semaphore legend panel — color-coded risk ranges for IPRA and IASH.
 *
 * Props:
 *   rows  {Array<{color, ipra, iash, risk}>}  from SUMMARY_SEMAPHORE_ROWS
 */
const ManCrossSemaphorePanel = ({ rows }) => (
    <div className="mgcr-panel">
        <div className="mgcr-panel-title">Semáforo</div>
        <div className="mgcr-semaphore-table">
            <div className="mgcr-semaphore-head">
                <span />
                <span>IPRA</span>
                <span>IASH</span>
                <span>RIESGO</span>
            </div>
            {rows.map((row) => (
                <div key={row.risk} className="mgcr-semaphore-row">
                    <span
                        className="mgcr-semaphore-dot"
                        style={{ background: row.color }}
                    />
                    <span>{row.ipra}</span>
                    <span>{row.iash}</span>
                    <span className="mgcr-semaphore-risk">{row.risk}</span>
                </div>
            ))}
        </div>
    </div>
);

export default ManCrossSemaphorePanel;
